<template>
  <div class="server-manager">
    <iframe class="iframe-placeholder"
            :src="dashboard"
            frameborder="0"
            width="100%"
            height="100%"
            allowtransparency
    ></iframe>
  </div>

</template>

<script>
import CustomTable from "@/component/CustomTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import CustomCard from "@/component/Performance/CustomCard";
import CustomDialog from "@/component/Performance/dialog/CustomDialog";
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import {
  exportFinancial,
  exportTodoList,
  getFinancial,
  getTodoList,
  getTodoListCount,
  getUnusualList
} from '../../api/api'
import {getMonthStartDate} from "@/utils/util";
export default {
  name: "ServerManage",
  components:{
  },
  data(){
    return {
      dashboard:"http://mb.szltech.com/public/dashboard/824a9451-e79d-4110-a4ed-cde3bc65b7cc"
    }
  },
  async mounted() {

  },

  methods:{

  }
}
</script>
<style lang="scss">
.server-manager{
  height: 100%;
}
.iframe-placeholder {
  background: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100% 100%"><text fill="%238B8B8B" x="50%" y="50%" font-family="\'Lucida Grande\', sans-serif" font-size="24" text-anchor="middle">页面加载中</text></svg>') 0px 0px no-repeat;
}
</style>

